import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class HistoryHotkeyMixin extends Vue {

    protected showHistoryModal: boolean = false;

    mounted(): void {
        console.log('%c Mounted HistoryHotkey', 'color: green');
        document.addEventListener("keyup", this.hotKeysListener);
    }

    beforeDestroy(): void {
        console.log('%c Destroying HistoryHotkey', 'color: magenta');
        document.removeEventListener("keyup", this.hotKeysListener);
    }

    hotKeysListener(e: KeyboardEvent): void {
        if (e.code === "F8") {
            this.showHistoryModal = !this.showHistoryModal;
        }
    }
}
